import { Fragment } from "react";
import { SectionMeta } from "../components/SectionMeta.jsx";

const BELIEFS = [
  <>AI won&apos;t replace creative people. <em>Boring people using AI</em> will replace boring people.</>,
  <>Small teams can beat large companies. <em>Most do.</em></>,
  <>Freedom <em>creates</em> better work.</>,
  <>Collaboration is the new currency.</>,
  <>The future belongs to <em>multi-skilled minds.</em></>,
  <>Talent is everywhere. Opportunity isn&apos;t. <em>We&apos;re the bridge.</em></>,
];

const MARQUEE_ITEMS = [
  { text: "The future belongs to tribes.", className: "" },
  { text: "★", className: "marquee-star" },
  { text: "Build with people, not for them.", className: "marquee-lime" },
  { text: "★", className: "marquee-star" },
  { text: "Talent is everywhere.", className: "" },
  { text: "★", className: "marquee-star" },
  { text: "Stay restless.", className: "marquee-serif" },
  { text: "★", className: "marquee-star" },
];

export function Manifesto() {
  return (
    <section className="manifesto" id="manifesto">
      <div className="manifesto-inner">
        <SectionMeta num="§ 06" label="Cultural manifesto" right="What we actually believe" />

        <h2 className="h-display reveal">
          We <em>believe…</em>
        </h2>

        <div className="manifesto-grid">
          {BELIEFS.map((content, i) => (
            <div key={i} className="manifesto-item reveal">
              <div className="n">{String(i + 1).padStart(2, "0")}</div>
              <div className="t">{content}</div>
            </div>
          ))}
        </div>

        <div className="marquee manifesto-marquee" aria-hidden="true">
          <div className="marquee-track marquee-track--manifesto">
            {[0, 1].map((pass) => (
              <Fragment key={pass}>
                {MARQUEE_ITEMS.map((item, i) => (
                  <span key={`${pass}-${i}`} className={item.className}>
                    {item.text}
                  </span>
                ))}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
